'use strict';

import angular from 'angular';


export default function($log, $http, $scope, entityService) {
	'ngInject';

	var vm = this;

	$scope.entityData = entityService.data;
	vm.callData = {};

	$scope.$watch('entityData', function(newValue, oldValue, scope) {
		if (!newValue || !newValue.roles) return;
		vm.entityDataFetched = true;
		initiateCallOrder();
	}, true);

	$http.get('/entity-data/call_order/').then(function success(response) {
		vm.callOrderFetched = true;
		vm.existingCallOrder = response.data.results[0];
		initiateCallOrder();
	});


	function range(n, delta) {
		if (!delta) delta = 0;
		var range = [0];
		for(var i = 1; i <= n+delta; i++) {
			range.push(i);
		}
		return range;
	}

	function initiateCallOrder() {
		if (!vm.initialCallOrderSet && vm.callOrderFetched && vm.entityDataFetched) {
			vm.initialCallOrderSet = true;
			vm.callOrderLists = {};
			vm.noCallLists = {};
			$scope.entityData.roles.forEach(function(role) {
				vm.callOrderLists[role.display_name] = [];
				vm.noCallLists[role.display_name] = [];
				role.users.forEach(function(user) {
					if (!user.is_active) return;
					if (
						vm.existingCallOrder
						&& vm.existingCallOrder.value
						&& vm.existingCallOrder.value[role.display_name]
						&& vm.existingCallOrder.value[role.display_name].indexOf(user.uuid) >= 0
					) {
						vm.callOrderLists[role.display_name].push(user);
					} else {
						vm.noCallLists[role.display_name].push(user);
					}
				});
				vm.callOrderLists[role.display_name].sort(function(a, b) {
					var aIndex = vm.existingCallOrder.value[role.display_name].indexOf(a.uuid);
					var bIndex = vm.existingCallOrder.value[role.display_name].indexOf(b.uuid);
					return aIndex - bIndex;
				});
				vm.callData[role.display_name] = {
					name: role.display_name,
					target_count: 0,
					range: range(role.users.filter(u => u.is_active).length),
					callList: vm.callOrderLists[role.display_name],
					noCallList: vm.noCallLists[role.display_name],
				};
			});
		}
	}

	vm.treeOptions = {
		accept: function(sourceNodeScope, destNodeScope, destIndex) {
			var sourceRole = sourceNodeScope.$parentNodesScope.$parent.$parent.roleName;
			var destRole = destNodeScope.$parent.$parent.roleName;
			return sourceRole == destRole;
		}
	};

	vm.moveToCallList = function(roleName, idx) {
		var user = vm.noCallLists[roleName][idx];
		vm.noCallLists[roleName].splice(idx, 1);
		vm.callOrderLists[roleName].push(user);
	}

	vm.moveToNoCallList = function(roleName, idx) {
		var user = vm.callOrderLists[roleName][idx];
		vm.callOrderLists[roleName].splice(idx, 1);
		vm.noCallLists[roleName].push(user);
	}

	vm.save = function() {
		if (!vm.callOrderLists || vm.saving) return;
		vm.saving = true;
		var data = {};
		for (var roleName in vm.callOrderLists) {
			data[roleName] = vm.callOrderLists[roleName].map(u => u.uuid);
		}
		$http.post('/entity-data/call_order/', {
			key: 'call_order',
			value: data,
		}).then(function success(response) {
			angular.merge(vm.existingCallOrder, response.data);
			vm.saving = false;
		}, function error(response) {
			alert('Error saving the call order');
			vm.saving = false;
		});
		vm.saving = false;
	}

	vm.options = {
		emergencyCall: false,
	};

	vm.processForCall = function() {
		vm.callRoles = [];
		vm.postData = {};
		for (var roleName in vm.callData) {
			var roleData = vm.callData[roleName];
			if (roleData.target_count > 0) {
				vm.callRoles.push(roleName);
				vm.postData[roleName] = {
					users: roleData.callList.map(u => u.uuid),
					target_count: roleData.target_count,
					call_time: vm.options.emergencyCall ? 5 : 300,
					min_call_count: vm.options.emergencyCall ? 3 : 1,
				};
			}
		}
	}
}
